"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _CareTeamImage = require("./CareTeamImage");
Object.keys(_CareTeamImage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CareTeamImage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _CareTeamImage[key];
    }
  });
});